import { css } from "@emotion/react";
import React from "react";
import type { ImmutableObject } from "@/lib/immutable";
import type { Catalog } from "../../../hooks/useCatalogState";
//import { useCheckoutFormState } from "../../../hooks/useCheckoutFormState";
import type { ProductCategoriesTree } from "../../../hooks/useInventoryState";
import { LoadingDots } from "../../LoadingDots";
import { DepartmentControl } from "./DepartmentControl";

//-------------------------------------------------------------------------------------------------------
export type CategoryTreeControlProps = {
	catalog?: Catalog | ImmutableObject<Catalog>;
	rentalCategoriesTree?: ProductCategoriesTree;
};
export const CategoryTreeControl: React.FC<CategoryTreeControlProps> = (
	props,
) => {
	//const inventoryState = useInventoryState();
	//const checkoutFormState = useCheckoutFormState();
	// const warehouse = checkoutFormState.getWarehouse();
	const departments = props.rentalCategoriesTree?.Departments;

	return (
		<>
			{(!props.catalog || !props.rentalCategoriesTree) && (
				<div
					css={css`
                display: flex;
                align-items: center;
                justify-content: center;
            `}
				>
					<LoadingDots />
				</div>
			)}
			{props.catalog &&
				departments &&
				departments.map((productDepartment) => (
					<React.Fragment key={productDepartment.Id}>
						<DepartmentControl
							catalog={props.catalog as Catalog}
							department={productDepartment}
							departments={departments}
						/>
					</React.Fragment>
				))}
		</>
	);
};
